<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">編輯會員資料</span>
          </div>
          <b-button class="border float-right" :to="`/admin/users/${uid}/more`">取消</b-button>
        </template>
        <b-row>
          <b-col md="6" offset-md="3">
            <b-form @submit.prevent="onSubmit">
              <b-form-group
                id="username-input-group"
                label-for="username-input"
                class="mb-3"
              >
                <template slot="label">會員帳號</template>
                <b-form-input
                  id="username-input"
                  :value="username"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="name-input-group"
                label-for="name-input"
                class="mb-3"
                :state="Boolean(name.length)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>會員名稱
                </template>
                <b-form-input
                  id="name-input"
                  v-model="name"
                  :state="Boolean(name.length)"
                  required
                  :disabled="busy"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="school_num-input-group"
                label-for="school_num-input"
                class="mb-3"
                :state="Boolean(school_num.length)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>學號
                </template>
                <b-form-input
                  id="school_num-input"
                  v-model="school_num"
                  :state="Boolean(school_num.length)"
                  required
                  :disabled="busy"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="tel-input-group"
                label-for="tel-input"
                class="mb-3"
                :state="Boolean(tel.length)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>連絡電話
                </template>
                <b-form-input
                  id="tel-input"
                  v-model="tel"
                  :state="Boolean(tel.length)"
                  required
                  :disabled="busy"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="email-input-group"
                label-for="email-input"
                class="mb-3"
                :state="validEmailState"
              >
                <template slot="label">
                  <span class="text-danger">*</span>電子信箱
                </template>
                <b-form-input
                  id="email-input"
                  v-model="email"
                  :state="validEmailState"
                  required
                  :disabled="busy"
                ></b-form-input>
              </b-form-group>
              <b-button variant="primary" type="submit" class="float-right">送出</b-button>
            </b-form>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { EmailRegExp } from '../../library/Var.js'
export default {
  data () {
    return {
      busy: false,
      username: '',
      name: '',
      tel: '',
      email: '',
      school_num: ''
    }
  },
  computed: {
    uid () {
      return this.$route.params.id
    },
    validEmailState () {
      return EmailRegExp.test(this.email)
    }
  },
  methods: {
    async fetch () {
      this.busy = true
      const { data: { username, name, tel, email, school_num: num } } = await this.$api.getUserById(this.uid)
      this.username = username
      this.name = name
      this.tel = tel
      this.email = email
      this.school_num = num
      this.busy = false
    },
    async onSubmit () {
      if (this.busy) return
      this.busy = true
      const data = {
        username: this.username,
        name: this.name,
        tel: this.tel,
        email: this.email,
        school_num: this.school_num
      }
      try {
        await this.$api.putUserInfo(data, this.uid)
        this.showSuccessMsg()
      } catch (err) {
        this.showErrorMsg()
      }
      this.busy = false
      this.fetch()
    },
    showSuccessMsg () {
      return this.$bvToast.toast('使用者已更新', {
        variant: 'success',
        title: '操作成功'
      })
    },
    showErrorMsg () {
      return this.$bvToast.toast('連線發生錯誤，資料更新失敗。', {
        variant: 'danger',
        title: '操作失敗'
      })
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>